/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, NgZone} from '@angular/core';
import * as _ from 'lodash';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import template from './third-party-audience-postcode-modal.component.html';
import {parsePostcodeUploadText} from './third-party-audience-postcode-upload';

@Component({
  standalone: false,
  selector: 'adn-third-party-audience-postcode-modal',
  template
})
export class ThirdPartyAudiencePostcodeModalComponent {
  @Input() submitPostcodes: (text: string, countryIsoCode: string) => Promise<any>;

  readonly onClosed = new Subject<void>();

  countryIsoCode = 'NO';
  postcodeText = '';
  validationErrors: any[] = [];
  uploadError: string | null = null;
  uploading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly ngZone: NgZone
  ) {
  }

  canSubmit(): boolean {
    return !!this.countryIsoCode && parsePostcodeUploadText(this.postcodeText).length > 0;
  }

  submit(): void {
    if (!this.canSubmit() || !this.submitPostcodes) {
      return;
    }

    this.validationErrors = [];
    this.uploadError = null;
    this.uploading = true;

    this.submitPostcodes(this.postcodeText, this.countryIsoCode).then((response) => {
      this.ngZone.run(() => {
        this.bsModalRef.hide();
        this.onClosed.next();
      });
      return response;
    }).catch((error) => {
      this.ngZone.run(() => {
        this.validationErrors = _.get(error, ['data', 'errors'], []);
        if (!this.validationErrors.length) {
          this.uploadError = _.get(error, ['data', 'message']) || _.get(error, ['message']) || 'The postcodes could not be uploaded.';
        }
      });
    }).finally(() => {
      this.ngZone.run(() => {
        this.uploading = false;
      });
    });
  }

  dismiss(): void {
    if (this.uploading) {
      return;
    }
    this.bsModalRef.hide();
    this.onClosed.next();
  }
}
